const AUTH_PATHNAMES = new Set([
    '/sign-up',
    '/set-password',
    '/forgot-password',
    '/login',
]);

const isAppRootPathname = (pathname: string) =>
    pathname === '' || pathname === '/';

/**
 * React-admin uses hash routing (#/resource). A mistaken pathname-only link
 * (e.g. href="/cloud-sync") leaves the browser at /cloud-sync#/other-route.
 * Collapse stray pathnames back to / while keeping hash and query string.
 */
export const normalizeHashRouterUrl = (
    location: Pick<Location, 'pathname' | 'hash' | 'search'> = window.location
): boolean => {
    const { pathname, hash, search } = location;

    if (AUTH_PATHNAMES.has(pathname) || isAppRootPathname(pathname)) {
        return false;
    }

    const normalizedHash =
        hash.length > 0 ? hash : `#/${pathname.replace(/^\//, '')}`;

    window.history.replaceState(null, '', `/${search}${normalizedHash}`);
    return true;
};
